import {default as data} from '../../package.json';

const environment = 
{
    VERSION: data.version,
    production: true,

    apiUrl : 'https://erieapisandbox.cyphersystem.com',
    courtUrl : 'https://eriesandboxcct.cyphersystem.com'
}

export { environment };
